/**
 * MLS Import Provider Constants
 */

export const PROVIDER_RELITIX = "relitix";
export const PROVIDER_COURTED = "courted";

export const VALID_PROVIDERS = [PROVIDER_RELITIX, PROVIDER_COURTED];

// Feature flags
export const COURTED_FEATURE_FLAG = process.env.SHAKAPACKER_PUBLIC_COURTED_DATA_SOURCE_FLAG;
export const COURTED_VARIANT_UPGRADE_CTA = "upgrade_cta";
